const validateProtocolAndDomain = value => value.match(/^[^@]+@[^@]+\.[^@]+$/) !== null;
const validateEmail = email => {
    if (!validateProtocolAndDomain(email)) {
        return 'globalSettingsInvalidEmailFormatTextIdLabel';
    }
};
export default validateEmail;
